import {
  AttachmentsAction,
  START_UPLOAD_ATTACHMENT,
  END_UPLOAD_ATTACHMENT,
  ADD_ATTACHMENT_REQUEST,
  UPLOAD_ATTACHMENTS_COMPLETED,
  REMOVE_ATTACHMENT,
  INITIALIZE_ATTACHMENTS,
  GET_SIGNED_URL_SUCCESS,
  UPLOAD_TO_S3_SUCCESS,
  UPLOAD_TO_S3_FAIL,
} from "./actionTypes";

interface AttachmentsState {
  uploadAttachment: boolean;
  attachments: any[];
  uploadError?: string | null;
  uploadedAttachments: number;
  attachment_to_add: any;
}

const INITIAL_STATE: AttachmentsState = {
  uploadAttachment: false,
  attachments: [],
  uploadedAttachments: 0,
  attachment_to_add: {},
};

export function reducer(
  state = INITIAL_STATE,
  action: AttachmentsAction
): AttachmentsState {
  switch (action.type) {
    case START_UPLOAD_ATTACHMENT:
      return {
        ...state,
        uploadAttachment: true,
      };
    case END_UPLOAD_ATTACHMENT:
      return {
        ...state,
        uploadAttachment: false,
      };
    case ADD_ATTACHMENT_REQUEST:
      return {
        ...state,
        attachment_to_add: action.attachment,
        uploadError: null,
        uploadAttachment: false,
      };
    case GET_SIGNED_URL_SUCCESS: {
      const attachment = { ...state.attachment_to_add };

      attachment.uploadUrl = action.result.signedPutUrl;
      attachment.imageUrl = action.result.publicReadUrl;

      // HACK: This is gross
      // TODO: Refactor this flow so that attachments can be passed
      // through with a key from `getSignedUrl`
      if ("key" in attachment !== true) {
        attachment.key = new Date().getTime();
      }

      const attachments = [...state.attachments, attachment];

      return {
        ...state,
        attachments,
        uploadAttachment: false,
        attachment_to_add: attachment,
      };
    }
    case UPLOAD_TO_S3_SUCCESS:
      return {
        ...state,
        uploadedAttachments: state.uploadedAttachments + 1,
      };
    case UPLOAD_TO_S3_FAIL:
      return {
        ...state,
        uploadError: action.error, // NOTE: Nothing is being done with this message
      };

    case UPLOAD_ATTACHMENTS_COMPLETED:
      return state;
    case REMOVE_ATTACHMENT: {
      const reducedAttachments = [...state.attachments];
      reducedAttachments.splice(
        reducedAttachments.indexOf(action.attachment),
        1
      );

      return {
        ...state,
        attachments: reducedAttachments,
        uploadError: null,
      };
    }
    case INITIALIZE_ATTACHMENTS:
      return {
        ...state,
        uploadedAttachments: 0,
        attachments: [],
        attachment_to_add: {},
      };
    default:
      return state;
  }
}
